// extracted by mini-css-extract-plugin
export default {"treeWrap":"DepartsTree_treeWrap__Vr2Cz","loading":"DepartsTree_loading__fvuFh"};